import { Gauge } from 'lucide-react';

import { descricaoDaUltimaLeitura, textoDaUltimaLeitura, type UltimaLeitura } from './ultima-leitura';

/**
 * A ETIQUETA DA ULTIMA LEITURA (decisao 54): ao lado do campo onde se digita o
 * horimetro ou o km, na mesa e no celular.
 *
 * E etiqueta, e nao selo (p.25): diz um atributo da maquina, neutra e de raio
 * 8, com o `gauge` do vocabulario (horimetro, medicao, p.19). A leitura que
 * ainda esta na fila deste aparelho vai no tom de informacao, para quem lanca
 * sem sinal saber que o numero e o dele e ainda nao chegou ao sistema.
 */
export function EtiquetaDaUltimaLeitura({
  leitura,
  unidade,
  contexto = 'mesa',
  curta = false,
}: {
  readonly leitura: UltimaLeitura | null;
  readonly unidade: 'h' | 'km';
  readonly contexto?: 'mesa' | 'celular';
  /** So o numero ("Última: 6.300 h"), para a coluna estreita da linha rapida; o quando fica no `title`. */
  readonly curta?: boolean;
}) {
  const inteiro = textoDaUltimaLeitura(leitura, unidade);
  const texto = curta ? inteiro.split(' · ')[0] ?? inteiro : inteiro;
  const descricao = descricaoDaUltimaLeitura(leitura, unidade);
  const tom = leitura?.doAparelho ? 'bg-informacao-fundo text-informacao-texto' : 'bg-rebaixada text-tinta-lista';
  return (
    <span
      title={descricao}
      /* `relative`: o `sr-only` de dentro e `position: absolute` e, sem um
         ancestral posicionado, estica o documento (LancamentoRapido, 25/10). */
      className={`relative inline-flex min-h-[var(--selo-altura)] max-w-full items-center gap-1 rounded-etiqueta px-2 py-0.5 ${tom} ${
        /* Na mesa, -my-1: a etiqueta (24 px) cabe na linha do rotulo sem a
           esticar, e o campo fica na mesma altura dos vizinhos da grade. */
        contexto === 'celular' ? 'txt-legenda' : 'txt-selo -my-1'
      }`}
    >
      <Gauge aria-hidden="true" className="size-[var(--icone-controle)] shrink-0" />
      <span aria-hidden="true" className={`tabular-nums ${curta ? 'whitespace-nowrap' : ''}`}>
        {texto}
      </span>
      <span className="sr-only">{descricao}</span>
    </span>
  );
}
